<template>
  <div class="qrcode-popup">
    <div @click="close" class="qrcode-popup-cover"></div>
    <div class="qrcode-popup-container">
      <div class="qrcode-container">
        <vue-qr :correctLevel="3" :autoColor="false" :logoSrc="logoSrc" :text="JSON.stringify(this.codeInfo)" :size="300" :margin="0" :logoMargin="3"></vue-qr>
      </div>
      <p class="title">{{ $t('scanSave') }}</p>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  name: "qrcode-popup",
  props: {
    selectedDApp: {
      type: Object
    }
  },
  data () {
    return {
      logoSrc: require(`../assets/img/logo/${this.selectedDApp['icon_name']}.png`),
      codeInfo: ''
    }
  },
  components: {
    VueQr
  },
  created() {
    this.codeInfo = {
      ...this.selectedDApp,
      protocol: "TIP-001",
      protocol_version: "1.0",
      icon_url: `https://raw.githubusercontent.com/dappcom/dapps/main/src/assets/img/logo/${this.selectedDApp['icon_name']}.png`
    }
    delete this.codeInfo['icon_name']
  },
  methods: {
    close() {
      this.$parent.showPopup = false
    }
  }
}
</script>

<style lang="less">
.qrcode-popup {
  .qrcode-popup-cover {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: fixed;
    background-color: rgba(0,0,0,0.7);
  }
  .qrcode-popup-container {
    width: 392px;
    height: 496px;
    border-radius: 32px;
    background-color: #fbfcff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    .qrcode-container {
      width: 344px;
      height: 344px;
      background-color: white;
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(39,97,231,0.07);
      border-radius: 0.16rem;
    }

    .title {
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: center;
      font-size: 20px;
      margin: 30px 24px 0;
    }
  }
}
</style>
